<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title">“I<span class="small">F</span> W<span class="small">E</span> A<span class="small">RE</span> S<span class="small">TRIKING</span> F<span class="small">OR</span> P<span class="small">ENNSYLVANIA</span>”</h1>
<p class="titlea">The Army of Northern Virginia and the Army of the Potomac March to Gettysburg</p>
<p class="titleaa">Volume 2: June 22–30, 1863</p>
<p class="author">SCOTT L. MINGUS Sr.</p>
<p class="authora"><span class="small">and</span> ERIC J. WITTENBERG</p>
<div class="image_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?8e8a84ca